/**
 * @file
 */
const state = {
    scrollY: null,
    scroll: null
};

const mutations = {
    setScrollY(state, payload) {
        state.scrollY = payload.scrollY;
        if (payload.scroll) {
            state.scroll = payload.scroll;
        }
    }
};

export default {
    state,
    mutations
};
